import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=6e5b02d8&scoped=true"
import script from "./archives.vue?vue&type=script&lang=js"
export * from "./archives.vue?vue&type=script&lang=js"
import style0 from "./archives.vue?vue&type=style&index=0&id=6e5b02d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b02d8",
  null
  
)

export default component.exports